import React from "react";
import BaseReportPage from "./_BaseReportPage";

const extractEarlyRemark = (remark = "") => {
  if (!remark) return "-";
  const parts = remark.split("|").map((x) => x.trim());
  const early = parts.find((p) => p.toLowerCase().startsWith("early"));
  return early || "-";
};

const columns = [
  { title: "Date", key: "date" },
  { title: "Code", key: "employee_code" },
  { title: "Name", key: "name", className: "text-start" },
  { title: "Shift Out", key: "shift_out" },
  { title: "Out Time", key: "out_time" },
  {
    title: "Remarks",
    key: "remarks",
    render: (value) => extractEarlyRemark(value),
  },
];

export default function EarlyReportPage() {
  return (
    <BaseReportPage
      apiEndpoint="/hrms/attendance"
      columns={columns}
      title="Early Going Report"
      emptyMessage="No early going records"
      defaultFilters={{ only: "early" }}
      downloadEndpoint="/hrms/attendance/download"
    />
  );
}
